const parseCookie = (name: string, cookies: string) => {
  const value = `; ${cookies}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length !== 2) return null;

  const cookieValue = parts.pop();
  if (!cookieValue) return null;

  return cookieValue.split(';').shift();
};

const getCookie = (name: string) => parseCookie(name, document.cookie);

const ONE_YEAR_IN_MS = 365 * 24 * 60 * 60 * 1000;
const DEFAULT_MAX_AGE = ONE_YEAR_IN_MS;

const setCookie = (
  name: string,
  value: string,
  options?: {
    maxAge?: number;
    path?: string;
  },
) => {
  const { maxAge = DEFAULT_MAX_AGE, path = '/' } = options || {};
  document.cookie = `${name}=${value};path=${path};max-age=${maxAge}`;
};

const getUtmCookies = () => {
  const [utmCampaign, utmSource, utmMedium, utmContent, utmTerm] = [
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_term',
  ].map(getCookie);

  return { utmCampaign, utmSource, utmMedium, utmContent, utmTerm };
};

/*
 * Parse a cookie value to a number. Used in embedded pages to set
 * the cookies to be what the parent domain has opted them into
 * @param defaultValue - The default value to return if the value is not set with the param
 * @param value - The value to parse and set the cookie to
 * @returns 1 if the value is '1' or 'true', 0 if the value is '0' or 'false', or the default value otherwise
 */
const parseParamsForEmbedCookieSetting = (
  paramValue: string | null | undefined,
  defaultValue: number,
): number => {
  if (!paramValue) return defaultValue;

  const formattedValue = paramValue?.toLowerCase();
  if (formattedValue === '1' || formattedValue === 'true') return 1;
  if (formattedValue === '0' || formattedValue === 'false') return 0;

  return defaultValue;
};

export {
  getCookie,
  setCookie,
  getUtmCookies,
  parseCookie,
  parseParamsForEmbedCookieSetting,
  DEFAULT_MAX_AGE,
};
